import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

const TOKEN_KEY = 'auth-token';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationCheckService {
  authenticationState: boolean = false;

  constructor(private router: Router) {
    this.checkToken();
  }

  /**
   * Check if token exists in localStorage and set auth state
   */
  checkToken(): void {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      this.authenticationState = true;
    }
  }

  /**
   * Get the stored auth token (without Bearer prefix)
   */
  getAuthToken(): string | null {
    const token = window.localStorage.getItem(TOKEN_KEY);
    if (!token) return null;
    // Remove any Bearer prefix and trim whitespace/control characters
    return token.replace(/^Bearer\s+/i, '').trim();
  }

  /**
   * Save authentication token
   * Note: Stores token WITHOUT Bearer prefix - the HTTP interceptor adds it
   */
  async saveAuth(token: string): Promise<boolean> {
    // Remove any existing Bearer prefix and trim whitespace/control characters
    const cleanToken = token.replace(/^Bearer\s+/i, '').trim();
    await localStorage.setItem(TOKEN_KEY, cleanToken);
    this.authenticationState = true;
    return true;
  }

  /**
   * Clear all localStorage and redirect to signin
   */
  logout(): Promise<boolean> {
    localStorage.clear();
    this.authenticationState = false;
    return this.router.navigateByUrl('/signin', { replaceUrl: true });
  }

  /**
   * Check if user is authenticated
   */
  isAuthenticated(): boolean {
    return this.authenticationState;
  }
}
